export const RightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_5405_7066)">
      <path
        d="M13.489 5.76281L10.8138 3.08765L9.989 3.91248L12.4752 6.39923L0 6.41673V7.5834L12.5102 7.5659L9.98842 10.0876L10.8132 10.9125L13.489 8.23731C13.8161 7.90861 13.9997 7.46377 13.9997 7.00006C13.9997 6.53636 13.8161 6.09151 13.489 5.76281Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5405_7066">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
